export enum Role {
  SUPER_ADMIN = 1,
  ADMIN,
  DEAN = 3,
  DEPARTMENT_MANAGER,
  PROGRAM_MANAGER = 5,
  COORDINATOR,
  INSTRUCTOR = 7,
  STUDENT,
  STAFF = 9,
  STATION_MANAGER,
  OBSERVER = 11,
}
export const staffRole = [
  Role.INSTRUCTOR,
  Role.COORDINATOR,
  Role.PROGRAM_MANAGER,
  Role.DEPARTMENT_MANAGER,
  Role.DEAN,
];

export const adminRole = [Role.SUPER_ADMIN, Role.ADMIN];

export const programManagerRole = [
  Role.PROGRAM_MANAGER,
  Role.DEPARTMENT_MANAGER,
  Role.DEAN,
  Role.ADMIN,
  Role.SUPER_ADMIN,
];

export const coordinatorRole = [
  Role.COORDINATOR,
  Role.PROGRAM_MANAGER,
  Role.DEPARTMENT_MANAGER,
  Role.DEAN,
  Role.ADMIN,
  Role.SUPER_ADMIN,
];

export const instructorRole = [
  Role.INSTRUCTOR,
  Role.COORDINATOR,
  Role.PROGRAM_MANAGER,
  Role.DEPARTMENT_MANAGER,
  Role.DEAN,
  Role.ADMIN,
  Role.SUPER_ADMIN,
];
export const departmentManagerRole = [
  Role.DEPARTMENT_MANAGER,
  Role.DEAN,
  Role.ADMIN,
  Role.SUPER_ADMIN,
];
export const deanRole = [Role.DEAN, Role.ADMIN, Role.SUPER_ADMIN];

export const ROLES = {
  1: 'roles.superAdmin',
  2: 'roles.admin',
  3: 'roles.dean',
  4: 'roles.departmentManager',
  5: 'roles.programManager',
  6: 'roles.coordinator',
  7: 'roles.instructor',
  8: 'roles.student',
  9: 'roles.staff',
  10: 'roles.stationManager',
  11: 'roles.observer',
};
